import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, Button, Checkbox, Link
} from '@mui/material';
import Logo from '@assets/icons/logo-login-icon.svg';
import PrivacyPolicyUtil from 'FielderUtils/PrivacyPolicyUtil';
import { setLogOutUser, setUserPolicyTrue } from '../../core/store/modules/session/sessionSlice';
import { acceptPrivacyPolicyRequest, recordLoginRequest } from '@core/api/account/account.service';
import './PrivatePolicy.css';

const PrivatePolicy = ({ closePrivatePolicy, setIsAcceptedPolicy, lan }) => {
  const dispatch = useDispatch();
  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [showAlertAccept, setShowAlertAccept] = useState(false);
  const handleClose = () => {
    dispatch(setLogOutUser());
    closePrivatePolicy();
  };
  const handleAcceptPolicy = () => {
    if (acceptPolicy) {
      const onSuccess = () => {
        dispatch(setUserPolicyTrue());
        recordLoginRequest();
        setIsAcceptedPolicy(true);
        closePrivatePolicy();
      };
      const loadingConfig = { dispatch };
      acceptPrivacyPolicyRequest(onSuccess, null,
        loadingConfig).then(r => console.log(r));
    } else setShowAlertAccept(true);
  };
  return (
    <Dialog
      open
      maxWidth="sm"
      fullWidth
      onClose={handleClose}
      PaperProps={{ className: 'Fielder-modals-content-border shadow-lg' }}
    >
      <DialogTitle className="Fielder-modals-create-edit-detail-header-border" sx={{ textAlign: 'center' }}>
        <Box display="flex" justifyContent="center" mb={2}>
          <img src={Logo} alt="Logo" style={{ height: 50 }} />
        </Box>
        <Typography variant="h6">{lan.privacyPolicyTilte}</Typography>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center' }}>
        <Typography sx={{ mb: 4 }}>{lan.privacyPolicyText1}</Typography>
        <Box display="flex" alignItems="center" sx={{ mb: 2, justifyContent: 'center' }}>
          <Checkbox
            checked={acceptPolicy}
            onChange={(e) => {
              console.log('checked', e.target.checked);
              setAcceptPolicy(e.target.checked);
              setShowAlertAccept(false);
            }}
            className="form-check-input labelCheckbox"
            id="checkbox-policy"
            name="checkbox-policy"
            sx={{
              mt: 0.2,
              p: 0,
              mr: 1,
              alignSelf: 'start'
            }}
          />
          <Typography variant="body2" sx={{ textAlign: 'left', pl: 1 }}>
            {lan.privacyPolicyCheckbox1}{' '}
            <Link
              href={PrivacyPolicyUtil.TERMS_OF_SERVICE_LINK}
              target="_blank"
              rel="noreferrer"
              className="href-color-and-size"
            >
              {lan.privacyPolicyCheckboxLink1}
            </Link>{' '}
            {lan.privacyPolicyText2}{' '}
            <Link
              href={PrivacyPolicyUtil.PRIVACY_POLICY_LINK}
              target="_blank"
              rel="noreferrer"
              className="href-color-and-size"
            >
              {lan.privacyPolicyCheckboxLink2}
            </Link>
          </Typography>
        </Box>

        {showAlertAccept && (
          <Box mt={2} className="alert alert-warning mb-0" role="alert" id="showAlert">
            {lan.acceptTermsAndConditions}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button
          variant="contained"
          type="submit"
          onClick={handleAcceptPolicy}
          className="btn btn-outline-primary btn-success Fielder-modal-btnsave-size error-message-btn-margin"
        >
          {lan.accept}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivatePolicy;
